import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=899c3b1c&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"
import style0 from "./Default.vue?vue&type=style&index=0&id=899c3b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899c3b1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default,AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default,TheCustomScroll: require('/web/components/TheCustomScroll.vue').default})
